import React from 'react';
import { AutoCompleteInput } from '../autocomplete-input/autocomplete-input';
import EnumCoreModule from '@src/public/js/enum-core';
import { z } from 'zod';

export const COUNTRY_SCHEMA = z.object({
    alpha2code: z.string().length(2, 'Must be exactly 2 characters'),
    name: z.string().min(1, 'Name is required')
});

export const CountrySelectInput = props => {
    const getyOptions = () => {
        let countries = [];

        EnumCoreModule.GetCountries().map(function(country) {
            countries.push(country.name);
        });

        countries = countries.sort((a, b) => a.name?.localeCompare(b.name));

        return countries.map(function(country) {
            let theCountry = EnumCoreModule.GetCountries().filter(d => d.name == country);
            return { label: theCountry[0].name, value: theCountry[0] };
        });
    };

    return (
        <AutoCompleteInput
            by='alpha2code'
            options={getyOptions()}
            className='tw-w-full'
            InputProps={{
                className: 'tw-text-[16px] tw-bg-white'
            }}
            {...props}
        />
    );
};
